import { atom } from 'jotai';
import { FlashbarProps } from 'src/common/UIComponents';

/**
 * Atom storing Cloudscape Flashbar messages for global notification management
 * Uses FlashbarProps.MessageDefinition[] type from @cloudscape-design/components
 * Empty array as initial state
 */
export const flashbarAtom = atom<FlashbarProps.MessageDefinition[]>([]);

/**
 * Monotonic counter incremented every time `clearFlashbarMessages()` is
 * called. The Orion FlashbarToastBridge subscribes to this counter so it can
 * dismiss any outstanding loading toasts when the page explicitly clears the
 * flashbar (e.g. when data finishes loading and the page calls
 * clearFlashbarMessages() to drop the persistent loading toast).
 */
export const flashbarClearCounterAtom = atom<number>(0);
